import React, { useState } from 'react'
import { string } from 'yup'
import { TradeGiftcard } from './TradeGiftcard'
import { IGiftCard } from './types'

export const GiftCard = ({ cards, image, name, isDisabled }: IGiftCard) => {
  const [isTradeModalOpen, setIsTradeModalOpen] = useState<boolean>(false)

  return (
    <div className='bg-black border border-white/10 rounded-xl px-2 pt-2 pb-4 flex flex-col items-center'>
      <div
        className={`w-full h-[200px] bg-no-repeat bg-cover bg-center rounded-xl overflow-hidden`}
        style={{ backgroundImage: `url(${image})` }}
      ></div>

      <p className='text-base text-white text-center mt-3'>
        {name}{''}
        {isDisabled && <p className='text-xs text-red-400'>Not available</p>}
      </p>

      <TradeGiftcard
        cards={cards}
        name={name}
        isDisabled={isDisabled}
        isTradeModalOpen={isTradeModalOpen}
        setIsTradeModalOpen={setIsTradeModalOpen}
      />
    </div>
  )
}
